// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1__1y","cls2":"Comments-cls2__rZ Comments-cls1__1y"};